module.exports = __webpack_public_path__ + "media/images/preguntas-1a0929313d7fceadb3b37e88f983f620.svg";